import { useQuery } from "@tanstack/react-query";

import { makeApiRequest } from "../../utils";
import { BULLMQ_JOBS_QUERY_KEY } from "../../../constants/queryKeys";

export const useFetchBullMQJobs = ({
  queueName,
  status = "waiting",
  start = 0,
  end = 49
}) => {
  return useQuery({
    queryKey: [BULLMQ_JOBS_QUERY_KEY, queueName, status, start, end],
    queryFn: async () => {
      const searchParams = new URLSearchParams({
        status,
        start: start.toString(),
        end: end.toString()
      }).toString();

      return makeApiRequest({
        endpoint: `/api/bullmq/jobs/${encodeURIComponent(queueName)}?${searchParams}`,
        method: "GET"
      });
    },
    enabled: !!queueName,
    refetchInterval: 3000 // Refresh every 3 seconds
  });
};
